export default __webpack_public_path__ + "static/media/0134.62d09850.png";